import consumer from "./consumer"

consumer.subscriptions.create("TrackingsChannel", {
  connected() {
    // Called when the subscription is ready for use on the server
    console.log("Connected to Trackings channel!");
  },

  disconnected() {
    // Called when the subscription has been terminated by the server
  },

  received(data) {
    // Called when there's incoming data on the websocket for this channel
    if (data.status === "success") {
      if (data.content === "tracking_response" && data.track_response) {
        let formatter = new JSONFormatter(data.track_response.output ? data.track_response.output : JSON.parse(data.track_response));
        $('#track_messages').append(moment().format("YYYY-MM-DD HH:mm  "));
        $('#track_messages').append(formatter.render());
        $("#track_messages > div.json-formatter-row.json-formatter-open > a").remove();
      } else {
        $('#track_messages').append(moment().format("YYYY-MM-DD HH:mm  ") + data.content + "<br />");
      }
    } else if (data.status === "error") {
      $('#track_messages').append(moment().format("YYYY-MM-DD HH:mm  ") + data.content + ' ' + data.error + "<br />");
    } else if (data.status === "finished") {
      $('#track_messages').append(moment().format("YYYY-MM-DD HH:mm  ") + data.content + "<br />");
    }
  }
});
